import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../contexts/AuthProvider";
import { updateProfile } from "firebase/auth";
import Spinner from "../../Component/Spinner";
const SignUp = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const { createUser, updateUser, signInWithGoogle, loading } =
    useContext(AuthContext);
  const [signupError, setSignUpError] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname || "/";

  if (loading) {
    return <Spinner></Spinner>;
  }

  const handleSignUp = (data) => {
    console.log(data.role, data.email, data.password);
    setSignUpError("");
    createUser(data.email, data.password)
      .then((result) => {
        const user = result.user;
        toast.success("Account create successfully !");
        console.log(user);
        updateProfile(user, { displayName: data.name })
          .then(() => {
            console.log("name Updated");
          })
          .catch((error) => {
            // An error occurred
            // ...
          })
          .then(() => {
            saveUser(data.role, data.name, data.email);
          })
          .catch((error) => console.log(error));
      })
      .catch((error) => {
        console.log(error.message);
        setSignUpError(error.message);
      });
  };

  const handleGoogle = () => {
    signInWithGoogle()
      .then((result) => {
        const user = result.user;
        console.log(user);
      })
      .catch((err) => console.error(err));
  };

  const saveUser = (role, name, email) => {
    const user = { role, name, email };
    fetch("https://bike-resell-server-hasanalibd.vercel.app/users", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("saveuser", data);
        reset();
        navigate(from, { replace: true });
        // navigate('/')
      });
  };

  return (
    <div className="h-[700px] flex justify-center items-cente my-10">
      <div className="w-96 p-6 shadow-md">
        <form onSubmit={handleSubmit(handleSignUp)}>
          <h1 className="text-4xl font-semibold text-center">Sign Up</h1>
          {signupError && <p className="text-red-600 my-2">{signupError}</p>}

          <div className="form-control w-full max-w-xs">
            <label className="label">
              {" "}
              <span className="label-text"></span>
            </label>
            <select
              {...register("role", { required: true })}
              className="select input-bordered w-full max-w-xs"
            >
              <option disabled selected>
                Select Account Type?
              </option>
              <option>Buyer</option>
              <option>Seller</option>
            </select>
          </div>

          <div className="form-control w-full max-w-xs">
            <label className="label">
              <span className="label-text">Name</span>
            </label>
            <input
              type="text"
              {...register("name", { required: true })}
              className="input input-bordered w-full max-w-xs"
            />
          </div>

          <div className="form-control w-full max-w-xs">
            <label className="label">
              <span className="label-text">Email</span>
            </label>
            <input
              type="email"
              {...register("email", {
                required: "Email address must be required?",
              })}
              className="input input-bordered w-full max-w-xs"
            />
            {errors.email && (
              <p className="text-red-600">{errors.email?.message}</p>
            )}
          </div>

          <div className="form-control w-full max-w-xs">
            <label className="label">
              <span className="label-text">Password</span>
            </label>
            <input
              type="password"
              {...register("password", {
                required: "Password must be required?",
                minLength: {
                  value: 6,
                  message: "Password must be at least 6 characters",
                },
                pattern: {
                  value: /(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])/,
                  message: "password must be strong",
                },
              })}
              className="input input-bordered w-full max-w-xs"
            />
            {errors.password && (
              <p className="text-red-600">{errors.password?.message}</p>
            )}
          </div>

          <input
            className="btn btn-accent w-full mt-3"
            value="Sign Up"
            type="submit"
          />
        </form>
        <div>
          <p className="my-1 text-center">
            Already have a account{" "}
            <Link className="text-secondary" to="/login">
              Please login?
            </Link>{" "}
          </p>
          <div className="divider">OR</div>
          <button onClick={handleGoogle} className="btn btn-outline w-full">
            CONTINUE WITH GOOGLE
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
